import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { Context } from 'bernie-context';

import { UitkFavoriteSwitch } from 'uitk-react-switch';
import { ShortlistStore } from 'stores/shortlist-store';
import { UIPageStore } from 'stores/ui-page-store';
import { HotelViewModel, PriceViewModel, ReviewsViewModel, ShortlistModel } from 'models';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { RouteStore } from 'bernie-core';
import { Level, liveAnnounce } from 'uitk-react-utils';
const TrackedFavoriteSwitch = ClickTracker(UitkFavoriteSwitch);

export interface FavoriteButtonProps {
  category: string;
  shortlistModel?: ShortlistModel;
  shortlist?: ShortlistStore;
  analytics?: AnalyticsStore;
  context?: Context;
  labelSave: string;
  labelRemove: string;
  uiPage?: UIPageStore;
  onSaveMessage?: string;
  id: string;
  referralObject?: {
    favorite?: {
      rfrr: string;
      linkName?: string;
    };
    unfavorite?: {
      rfrr: string;
      linkName?: string;
    };
  };
  replayHotelModel?: HotelViewModel;
  rfrr?: string;
  onClick?: () => void;
  routeStore?: RouteStore;
  currentHotel?: CurrentHotelStore;
  price?: PriceViewModel;
  stars?: string;
  reviews?: ReviewsViewModel;
}

@inject('shortlist', 'context', 'analytics', 'uiPage', 'routeStore')
@observer
export class FavoriteButton extends React.Component<FavoriteButtonProps> {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  public handleClick() {
    const { shortlist, context, uiPage, shortlistModel, category, onClick, onSaveMessage } = this.props;

    const meta = shortlistModel && shortlistModel.meta;
    const hotelId = meta && meta.hotelId && Number(meta.hotelId);
    const favoritedLocallyVal =
      shortlist[category] && shortlist[category].favoritedLocally && shortlist[category].favoritedLocally[hotelId];
    const storeVal = this.existInStores();
    const initialFavState = typeof favoritedLocallyVal !== 'boolean' || favoritedLocallyVal === storeVal ? storeVal : favoritedLocallyVal;
    const updatedFavState = !initialFavState;

    if (shortlist) {
      if (typeof shortlist.updateFavoritedLocally === 'function') {
        shortlist.updateFavoritedLocally(hotelId, updatedFavState, 'hotel');
      }

      if (typeof shortlist.fetch === 'function') {
        const url = updatedFavState ? shortlistModel && shortlistModel.saveUrl : shortlistModel && shortlistModel.removeUrl;
        shortlist.fetch(url, context, meta, category);
      }

      if (this.replayHotelModel) {
        const replayModel = {
          ...this.replayHotelModel,
          reviews: {
            ...this.replayHotelModel.reviews,
            localizedCount: ''
          },
          price: {
            ...this.replayHotelModel.price,
            strikeOut: ''
          }
        };

        shortlist.updateFavorited(updatedFavState, replayModel, category);
      }
    }
    if (updatedFavState && uiPage && typeof uiPage.showNotification === 'function') {
      uiPage.showNotification(onSaveMessage);
      liveAnnounce(onSaveMessage, Level.POLITE);
    }

    this.fireTrackingEvent();
    if (typeof onClick === 'function') {
      this.props.onClick();
    }
  }

  private fireTrackingEvent() {
    const { shortlist, analytics } = this.props;
    const category = 'hotel';

    if (shortlist && shortlist[category] && shortlist[category].favorited) {
      const trackingDataNumberOfHearted = {
        rfrr: `FavoritedHotels.${shortlist[category].favorited.length}`,
        linkName: 'Number of favorited hotels'
      };
      analytics.trackEvent(trackingDataNumberOfHearted.rfrr, trackingDataNumberOfHearted.linkName, analytics.omnitureData, null);
    }
  }

  public getReferrals() {
    const referralObject = this.props.referralObject || {};
    const defaultFavorite = {
      rfrr: 'Scratchpad.SaveFavorite',
      linkName: 'Add to favorite lists'
    };
    const defaultUnfavorite = {
      rfrr: 'Scratchpad.RemoveFavorite',
      linkName: 'Remove from favorite lists'
    };

    return {
      ...referralObject,
      favorite: {
        ...defaultFavorite,
        ...referralObject.favorite
      },
      unfavorite: {
        ...defaultUnfavorite,
        ...referralObject.unfavorite
      }
    };
  }

  private existsInShortlist() {
    const { shortlist, category, shortlistModel } = this.props;
    const meta = shortlistModel && shortlistModel.meta;
    const hotelId = meta && meta.hotelId && Number(meta.hotelId);
    const favorited = shortlist && shortlist[category] && shortlist[category].favorited;

    return favorited && favorited.some(e => e.id === hotelId);
  }

  private existInStores(): boolean {
    const { shortlistModel } = this.props;

    return this.existsInShortlist() || (shortlistModel && shortlistModel.favorited);
  }

  private get replayHotelModel() {
    if (this.props.replayHotelModel !== undefined) {
      return this.props.replayHotelModel;
    }

    const { currentHotel, price, reviews, routeStore, stars, shortlistModel } = this.props;
    const meta = shortlistModel && shortlistModel.meta;
    const hotelId = meta && meta.hotelId && Number(meta.hotelId);
    const hotelName = currentHotel && currentHotel.hotel && currentHotel.hotel.name;
    const pathname: string = routeStore && routeStore.pathname;
    const search: string = routeStore && routeStore.search;
    const leadPrice: string = price && price.lead ? price.lead : currentHotel && currentHotel.getCheapestPrice();

    return {
      ...this.props,
      name: hotelName,
      id: hotelId,
      price: {
        ...price,
        lead: leadPrice
      },
      reviews: {
        superlative: reviews && reviews.superlative,
        localizedOverallRating: reviews && reviews.localizedOverallRating
      },
      infositeUrl: `${pathname}${search}`,
      stars: stars && typeof Number(stars) === 'number' ? Number(stars) : null
    };
  }

  public render() {
    const { shortlist, shortlistModel, id, category } = this.props;
    const meta = shortlistModel && shortlistModel.meta;
    const referralObject = this.getReferrals();
    const hotelId = meta && meta.hotelId && Number(meta.hotelId);
    const favoritedLocallyVal = shortlist[category].favoritedLocally && shortlist[category].favoritedLocally[hotelId];
    const storeVal = this.existInStores();
    // Check for local favorited value. If nonexistent or equal to the model value, use model value.
    // If not use local value as first priority.
    const isFavorited = typeof favoritedLocallyVal !== 'boolean' || favoritedLocallyVal === storeVal ? storeVal : favoritedLocallyVal;
    const label = isFavorited ? this.props.labelRemove : this.props.labelSave;
    const rfrr = isFavorited ? referralObject.unfavorite.rfrr : referralObject.favorite.rfrr;
    const linkName = isFavorited ? referralObject.unfavorite.linkName : referralObject.favorite.linkName;

    return (
      <TrackedFavoriteSwitch id={id} label={label} checked={isFavorited} onChange={this.handleClick} rfrr={rfrr} linkName={linkName} />
    );
  }
}
